import { DOCUMENT_PRESENTATION } from '../../composables/useCustomerInternationalConfig';

const DOCUMENT_LABELS = DOCUMENT_PRESENTATION as Record<string, { label: string }>;

/**
 * Rótulo do documento para a listagem: "CPF: 12345678900", "RUT: 12345678K".
 *
 * O tipo vem do banco em minúsculas ('cpf', 'rut', ...) e é nulo nas linhas
 * anteriores ao campo — nesse caso cai no rótulo genérico, mesmo fallback que
 * SOOrdersTable usa. Sem documento, célula vazia (não "Documento: ").
 */
export function formatDocumento(
  documento: string | null | undefined,
  tipo: string | null | undefined,
  t: (key: string) => string,
): string {
  const valor = (documento ?? '').trim();
  if (valor === '') {
    return '';
  }
  const chave = (tipo ?? '').trim().toLowerCase();
  const rotulo = DOCUMENT_LABELS[chave]?.label ?? (chave === '' ? t('Documento') : chave.toUpperCase());
  return `${rotulo}: ${valor}`;
}

export function formatStatusBadge(
  status: number | null | undefined,
  t: (key: string) => string,
): { label: string; severity: 'success' | 'secondary' } {
  if (status === 1) {
    return { label: t('Ativo'), severity: 'success' };
  }
  return { label: t('Inativo'), severity: 'secondary' };
}
